export default new class Orders {
    
    constructor() {
        let $orderListPage = $('.order-list-page');
        this.orderListPageLength = $orderListPage.length;

        if(this.orderListPageLength > 0) {
            this.filterAjaxRequest();
            this.sortingAjaxRequest();
            this.paginationAjaxRequest();
        }
    }
    
    paginationAjaxRequest() {
        
        $('._order-list-wrapper').on('click', '.received-order__pagination a', (e) => {
            e.preventDefault();

            let _this = $(e.target);
            $('.received-order__pagination').remove();
            
            $.request('OrderList::onAjaxRequest', {
                data: {
                    'page': _this.attr('data-page'),
                    'status': $('.catalog-search__radio-group input:checked').val(),
                },
                loading: '.js-preloaderOverlay',
                update: {'order_list': '@._order-list-wrapper'},
            });
        });
    }
    
    filterAjaxRequest() {
        $('.order-list-page').on('change', '.catalog-search__radio-group input', (e) => {
            $.request('OrderList::onAjaxRequest', {
                data: {
                    'status': $('.catalog-search__radio-group input:checked').val(),
                },
                loading: '.js-preloaderOverlay',
                update: {'order_list': '._order-list-wrapper'},
            });
        });
    }

    sortingAjaxRequest() {
        window.sortingShopaholicAjaxRequest = () => {
            $.request('OrderList::onAjaxRequest', {
                data: {
                    'status': $('.catalog-search__radio-group input:checked').val(),
                },
                loading: '.js-preloaderOverlay',
                update: {'order_list': '._order-list-wrapper'},
            });
        };
    }
};


// WEBPACK FOOTER //
// ./src/pages/orders/Orders.js